import { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Grid from '@mui/material/Grid';
import { OVCheckbox } from "../../../utils/mui-rhf";
import createLazyQuery from "../../../utils/gql-mui-rhf/LazyQuery"
import { FormProvider, useForm } from "react-hook-form";
import { useMutation } from '@apollo/client';
import { gql } from '@apollo/client';

const CREATE_FIELD_READY_ROLES = gql`
    mutation createFieldReadyRoles($fieldReadyRoles: [InputFieldReadyRoleParams]) {
        createFieldReadyRoles(fieldReadyRoles: $fieldReadyRoles) {
                roleId
                project {
                    id
                    name
                }
        }
    }
`

export default function AddFieldReadyRoleToProject({ project, open, handleClose, fieldReadyRoles, refetchFieldReadyRoles }) {
    const [roles, setRoles] = useState([]);
    const onGetRoleTypes = (data) => {
        let options = []
        data.roleTypes
            .forEach((roleType) => {
                if (!fieldReadyRoles.some((fieldReadyRole) => { return roleType.id === fieldReadyRole.roleId })) {
                    options.push({
                        value: roleType.id,
                        formValue: {
                            roleId: roleType.id,
                            projectId: project.id
                        },
                        name: roleType.name,
                        label: roleType.name,
                    })
                }
            })
        options.sort((a, b) => a.label.localeCompare(b.label));
        setRoles(options)
    }
    const onError = () => { debugger }
    const [getRoleTypes] = createLazyQuery("roleTypes", onGetRoleTypes, onError);

    useEffect(() => {
        if (project.id) {
            getRoleTypes({
                variables: {
                    active: true,
                    entity: "PERSON",
                }
            })
        }
    },
        [project, fieldReadyRoles, getRoleTypes])

    const methods = useForm({ defaultValues: { fieldReadyRoles: [] } });
    const { handleSubmit, } = methods;
    const [mutate] = useMutation(CREATE_FIELD_READY_ROLES);
    const onSubmit = (data) => {
        const variables = { ...data };
        mutate({ variables })
            .then((res) => {
                refetchFieldReadyRoles()
                handleClose()
            })
            .catch((e) => {
                console.log(e);
            });
    };
    return <Dialog
        open={open}
        onClose={() => {
            methods.reset()
            handleClose()
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
    >
        <DialogTitle id="alert-dialog-title">
            {`Select Field Ready Role to Add to Project`}
        </DialogTitle>
        <FormProvider {...methods}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogContent>
                    <Grid item xs={12} style={{ marginBottom: 32 }}>
                        <OVCheckbox
                            rules={{ required: "select one or many" }}
                            description={"Field Ready Role"}
                            fieldName={"fieldReadyRoles"}
                            options={roles}
                            valueField={"roleId"}
                        />
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" type="submit">
                        {"Submit"}
                    </Button>
                    <Button onClick={() => {
                        methods.reset()
                        handleClose()
                    }}>Cancel</Button>
                </DialogActions>
            </form>
        </FormProvider>
    </Dialog>
}
